/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input } from '@angular/core';

export type RiskItem = {
    risk_id: string;
    title: string;
    description: string;
    impact: string;
    recommended_action: string;
};

export type RiskAnalysis = {
    overall_result: {
        overall_risk_level: string;
        summary: string;
    };
    risk_sections: {
        high_risk: RiskItem[];
        medium_risk: RiskItem[];
        low_risk: RiskItem[];
    };
    action_summary: {
        must_do: string[];
        should_do: string[];
        optional: string[];
    };
};

@Component({
    selector: 'app-risk-analysis',
    templateUrl: './risk-analysis.component.html',
    styleUrl: './risk-analysis.component.scss'
})
export class RiskAnalysisComponent {
    @Input() public riskAnalysis: RiskAnalysis | null = null;

    public getRiskLevelClass(): string {
        if (!this.riskAnalysis) return '';
        const level = this.riskAnalysis.overall_result.overall_risk_level.toLowerCase();
        return `risk-level-${level}`;
    }
}
